import { QueryClient, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../../constants';
import { usersService } from '../../services';
import { useCallback } from 'react';

export const prefetchGetPublicUserByUserNameQuery = async (queryClient: QueryClient, userName: string) => (
	await queryClient.prefetchQuery({
		queryKey: queryKeys.user(userName),
		queryFn: async () => usersService.getByUsername(userName, {
			withEventsCount: true, withFriendsAndFollowersCount: true, withFriendsAndFollowersList: false
		}),
		staleTime: 60000
	})
);

export const usePrefetchGetPublicUserByUserNameQuery = () => {
	const queryClient = useQueryClient();

	return useCallback(async (userName: string) => await prefetchGetPublicUserByUserNameQuery(queryClient, userName), [queryClient]);
};

export const useGetPublicUserByUserNameQuery = (userName: string) => (
	useQuery(
		queryKeys.user(userName),
		async () => usersService.getByUsername(userName, {
			withEventsCount: true,
			withFriendsAndFollowersCount: true,
			withFriendsAndFollowersList: false
		}),
		{ enabled: !!userName, staleTime: 60 * 1000 })
);
